export enum DataTypeEnum {
    CatalogueUsers = "CatalogueUsers",
    DefaultMessages = "DefaultMessages",
}
